<div mat-dialog-title class="dialog-info d-flex align-items-center justify-content-between horizontal-padding">
    <label class="labelTitle">
        {{ 'NOTIFICATIONS' | translate }}
    </label>
    <button type="button" 
    class="btn-close btn-close-white shadow-none crossButtonPosition" 
    (click)="closeElement()"
    ></button>
</div>
<mat-dialog-content class="table-container">
    <div class="table-responsive">
            <table mat-table [dataSource]="messageDataSource" class="compact-table no-select">
                <ng-container matColumnDef="delete">
                    <th mat-header-cell *matHeaderCellDef> {{'DELETE' | translate}} </th>
                    <td mat-cell class="text-center" *matCellDef="let element">
                        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                            (change)=" onSelectionChange($event,element)"
                            [checked]="selection.isSelected(element)" 
                            [aria-label]="checkboxLabel(element)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="message">
                    <th mat-header-cell *matHeaderCellDef> {{'MESSAGE' | translate}} </th>
                    <td mat-cell *matCellDef="let element"
                        class="no-select"
                        [ngClass]="element.read? 'read-message' : 'unread-message'">
                        {{element.message}}
                    </td>
                </ng-container>
                <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="openMessageContent(selectedRow!)">
                            <mat-icon class="icons">open_in_new</mat-icon>
                            {{'OPEN_MESSAGE' | translate}} </button>
                        <button mat-menu-item (click)="deleteSelectedRow(selectedRow!)">
                            <mat-icon class="delete-icons">delete</mat-icon>
                            {{'DELETE_MESSAGE' | translate}} </button>
                        <button mat-menu-item (click)="markAsUnread(selectedRow!)">
                            <mat-icon class="mail-icons">mail</mat-icon>
                            {{'MARK_AS_UNREAD' | translate}} </button>
                        <button mat-menu-item (click)="markAllAsRead()">
                            <mat-icon class="icons">done_all</mat-icon>
                            {{'MARK_ALL_AS_READ' | translate}} </button>
                    </mat-menu>
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef> {{'DATE' | translate}} </th>
                    <td mat-cell *matCellDef="let element" class="no-select"
                        [ngClass]="element.read? 'read-message' : 'unread-message'">
                        {{element.date | multilingualDate : 'dateTime' : false}}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    (click)="onRowClick(row)"
                    (contextmenu)="onRightClick($any($event), menuTrigger, row)"
                    [class.selected-row]="isRowSelected(row)"
                    (dblclick)="openMessageContent(row)" class="row-dblclick">
                </tr>
            </table>
            <span class="menu-span" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
                      [style.left]="menuPosition.x" [style.top]="menuPosition.y"></span>
    </div>
</mat-dialog-content>
